
<template>
  <div class="keyword-select" ref="selectGoodInfo">
    <el-input class="search-text is-input"
              :class="{'is-clear':clearable}"
              ref="selectStartInput"
              :placeholder="isHasSelectValue?'':placeholder"
              v-popover:startPopover
              v-model="searchText"
              :disabled="disabled"
              @click.stop="noEvent"
              @blur="handlerBlur"
              @focus="handlerFocus"
              @keyup.enter.native="handlerEnter"
    ></el-input>
    <div class="value-text"
         :class="[showTextStatus,clearable?'is-clear':'']"
    >
      <slot>
        <div class="text-row">
          {{ multipleShowName }}
        </div>
      </slot>
    </div>
    <div class="btn-delete" v-if="clearable && isHasSelectValue && !disabled">
      <i class="icon el-icon-circle-close" @click="clickClear"></i>
    </div>
    <el-popover
      popper-class="input-popover-template-popper"
      :visible-arrow="false"
      ref="startPopover"
      trigger="manual"
      placement="bottom-start"
      @show="handlerShow"
      :width="popoverWidth"
      :offset="offset"
      v-model="visiblePopover"
    >
      <div class="alter-place-bpx">
        <template>
          <div v-if="list.length > 0">
            <div class="history-search">
              <div>货物类型</div>
            </div>
            <div class="group-wrap">
              <div
                class="group-wrap__item"
                :class="{'is-active':judgeItemIsSelect(item)}"
                v-for="item in list"
                :key="item.goodsTypeId"
                @click="selectItem(item)"
              >
                <el-tooltip :content="item.goodsTypeName" placement="top" v-if="item.goodsTypeName.length > 5">
                  <span class="innerText">{{ item.goodsTypeName }}</span>
                </el-tooltip>
                <span class="innerText" v-else>{{ item.goodsTypeName }}</span>
              </div>
            </div>
          </div>
          <template v-else-if="isLoading">
            <div class="hint-row"><i class="el-icon-loading"></i> {{ loadingText }}</div>
          </template>
          <template v-else>
            <div class="hint-row"><i class="el-icon-warning-outline"></i> {{ noDataMessage }}</div>
          </template>
          <div class="good-name-warp">
            <div class="hot-search">商品名称（选填）</div>
            <el-input
              class="goods-name-input"
              placeholder="请输入选择"
              v-popover:goodsNamePopover
              @focus="showGoodNamePopover('1')"
              @input="(val) => {
                showGoodNamePopover('2'), searchChange(val)
              }"
              v-model="goodNameText"
              style="width: 100%;"
            ></el-input>
          </div>
          <el-button type="primary" class="confirm-button" @click="confirm">确认</el-button>
        </template>
      </div>
    </el-popover>
    <el-popover
      popper-class="input-popover-template-popper"
      :visible-arrow="false"
      ref="goodsNamePopover"
      trigger="manual"
      placement="bottom-start"
      title=""
      :offset="offset"
      v-model="visibleGoodsPopover"
      @show="handlerShow"
    >
      <div v-if="showType === '1'" class="goods-list-box">
        <div v-if="levelLoading">
          <i class="el-icon-loading"></i> 正在加载中...
        </div>
        <template v-else>
          <div class="goods-type-level1" v-if="firstList.length">
            <ul>
              <li v-for="(item, i) in firstList" :key="i" :class="{isActive: firstActive && firstActive.id === item.id}" @click="selectFirst(item)">
                {{ item.productTypeFirstName }}
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
          </div>
          <div class="goods-type-level1" v-else>
            <p>抱歉，暂无数据</p>
          </div>
          <div class="goods-type-level2" v-if="firstActive">
            <ul v-if="secondList.length">
              <li v-for="(item, i) in secondList" :key="i" :class="{isActive: secondActive && secondActive.id === item.id}" @click="selectSecond(item)">
                <div>
                  {{ item.productTpeSecondaryName }}
                  <p class="price-info">加收 {{ item.price || 0 }} {{ item.currency || 'CNY' }}/{{item.billingUnit || 'KG'}}</p>
                </div>
                <i class="el-icon-arrow-right"></i>
              </li>
            </ul>
            <p v-else>抱歉，暂无数据</p>
          </div>
          <div class="goods-type-level3" v-if="firstActive && secondActive">
            <el-input v-model="searchInfo" placeholder="请输入商品名称搜索" @input="searchInfoChange"></el-input>
            <div class="product-wrap">
              <ul v-if="productItems.length && !searchInfo">
                <li :title="item.productName" v-for="item in productItems" :key="item.id" :class="{isActive: productActive && item.id === productActive.id}" @click="selectProductItem(item, '1')">{{ item.productName }}</li>
              </ul>
              <ul v-else-if="searchInfoFilerList.length && searchInfo">
                <li :title="item.productName" v-for="item in searchInfoFilerList" :key="item.id" :class="{isActive: productActive && item.id === productActive.id}" @click="selectProductItem(item, '1')">{{ item.productName }}</li>
              </ul>
              <div v-else style="min-width: 224px; padding: 32px 0 54px 0;text-align: center;">
                <img :src="ossPath + '/pages/home/no-data.png'" alt="">
                <p style="margin-top: 33px">抱歉，暂未找到相关产品品名</p>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div v-else class="goods-options">
        <div v-if="isLoading">
          <i class="el-icon-loading"></i> 正在搜索中...
        </div>
        <template v-else>
          <ul v-if="productList.length">
            <li class="goods-option" :class="{isActive: selectedValue && item.id === selectedValue.id}" v-for="item in productList" :key="item.id" @click="selectSearchItem(item, '2')">
              <span  style="display:inline-block; width: 200px; margin-right: 10px;">
                {{item ? `${item.goodsName || item.namec}${item.secondName || item.productTypeName ? `/${item.secondName || item.productTypeName}` : ''}${item.firstName || item.productName ? `/${item.firstName || item.productName}` : ''}` : '' }}
              </span>
              <span style="float: right; color: #FF4D01; font-size: 13px"><span style="color: #444">加收 </span>{{ item.surcharge || item.price || 0 }} {{ item.currency || 'CNY' }}/{{item.billingUnit || 'KG'}}</span>
            </li>
          </ul>
          <div v-else align="center" style="min-width: 330px; padding: 32px 0 54px 0">
            <img :src="ossPath + '/pages/home/no-data.png'" alt="">
            <p style="margin-top: 33px">{{searchText ? '抱歉，暂未找到相关产品品名' : '请输入商品名称搜索'}}</p>
          </div>
        </template>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {debounce, isArray, isObject} from "my-tools-kit";
export default {
  name: "searchSelectGood",
    props: {
      value:{ // 选中值,单选Object,多选Array
        type:[Object,Array],
        default:() => {
          return {}
        },
      },
      multiple:{ // 是否支持多选
        type:Boolean,
        default:false,
      },
      clearable:{ // 是否可清空
        type:Boolean,
        default:true,
      },
      disabled:{ // 输入框是否禁用，禁用情况下点击输入框页无法弹出列表
        type:Boolean,
        default:false,
      },
      placeholder:{ //输入框提示信息
        type:String,
        default:"请选择货物类型",
      },
      maxSelectNumber:{ //最大选择数量,为零时不限制，只在选择某个item操作后截断处理。
        type:Number,
        default:0,
      },
      list:{ // 列表
        type:Array,
        default:()=>[],
      },
      isLoading:{ // 显示 正在请求数据中...
        type:Boolean,
        default:false,
      },
      loadingText:{
        type:String,
        default:"正在请求数据中...",
      },
      noDataMessage:{ //列表为空时的提示信息
        type:String,
        default:"暂未找到您要的信息",
      },
      popoverWidth:{ //弹出层宽度
        type:String,
        default:"360",
      },
      offset:{ //出现位置的偏移量
        type:Number,
        default:0,
      },
      idKey:{ // 对选中数据进行匹配校验的字段
        type:String,
        default:"goodsTypeId",
      },
      productList: {
        type: Array,
        default: () => []
      },
      countryId: {
        type: [String, Number],
        default: ''
      },
      labelKey:{ // 显示在输入框的文本取值字段
        type:String,
        default:"goodsTypeName",
      },
  },
  data() {
    return {
      searchText:"",//输入框搜索文本
      selectedValue:[{ goodsTypeName: '全部', goodsTypeId: 0 }],
      visiblePopover:false,// 显示弹出层
      visibleGoodsPopover: false,
      showType: null,
      levelLoading: false,
      firstList: [],
      firstActive: null,
      secondActive: null,
      searchInfo: '',
      secondList: [],
      productItems: [],
      productActive: null,
      searchInfoFilerList: [],
      searchInfoLoading: false,
      goodNameText: '',
      selectProduct: null,
      // 多选时展示的选中文本
      multipleShowName: '全部',
      isFocus:false,//当前输入框是否获得焦点
    }
  },
  computed: {
    /**
     * 回显文本状态 class
     * @returns {string}
     */
    showTextStatus(){
      // 搜索框有输入值
      if(this.searchText.length) return "opacity-0"
      // 搜索框没有输入值，但是聚焦状态
      if(this.isFocus) return "opacity-04"
      return "";
    },
    /**
     * 是否有选中值
     * @returns {*}
     */
    isHasSelectValue(){
      // 有选中值时 输入框不显示placeholder
      let list = this.selectedValue;
      console.log('has', list.some((res={})=>res[this.idKey]||res[this.idKey]===0))
      return isArray(list) && list.length && list.some((res={})=>res[this.idKey]||res[this.idKey]===0);

      // if(this.multiple){
      //   return isArray(this.value) && this.value.length && this.value.some((res={})=>res[this.idKey]||res[this.idKey]===0);
      // }else{
      //   return this.value[this.idKey]||this.value[this.idKey]===0
      // }
    },
    /**
     * 多选时展示的选中文本
     */
    // multipleShowName(){
    //   let list = this.selectedValue;
    //   if(!isArray(list)) return "";
    //   let name = list.map((res={})=>{
    //     return res[this.labelKey]|| res[this.idKey]
    //   }).join(",");
    //   if (this.selectProduct) {
    //     name += `/${this.selectProduct.goodsName}/${this.selectProduct.secondName}`
    //   }
    //   return name
    // },
  },
  watch: {
    value:{
      immediate:true,
      handler: function (newValue) {
        let goodType = this.list.find(item => {
          return item.goodsTypeId === newValue.goodstypeId
        });
        if (!goodType) goodType = { goodsTypeName: '全部', goodsTypeId: 0 }
        this.selectedValue = [goodType]
        this.selectProduct = newValue.productName || ''
        this.setName()
      },
    },
    countryId() {
      this.selectProduct = null
      this.levelData = []
      this.firstList = []
      this.firstActive = null
      this.secondList = []
      this.secondActive = null
      this.productItems = []
      this.searchInfo = ''
      this.searchInfoFilerList = []
    }
  },
  methods: {
    /**
     * 根据 单选/多选 类型处理默认选中值为selectValue所需的格式
     */
    receiveDefaultValue(value){
      let list = [];
      if(this.multiple){
        if(isArray(value)) list = value.concat([]);
      }else{
        if(isObject(value)) list = [value];
      }
      return list;
    },
    /**
     * 失去焦点时触发
     */
    handlerBlur(){
      this.isFocus = false;
      this.$emit('blur');
      // this.hideListPopover();
    },
    /**
     * 获得焦点时触发
     */
    handlerFocus(){
      this.isFocus = true;
      this.$emit('focus');
      this.showListPopover();
    },
    /**
     * 按下回车时触发
     */
    handlerEnter(){
      console.log('按下回车')

    },
    /**
     * 清空
     */
    clickClear(){
      let value;
      if(this.multiple){
        value = [];
      }else{
        value = {
          goodType:{ goodsTypeName: '全部', goodsTypeId: 0 }
        };
      }
      this.selectedValue = [{ goodsTypeName: '全部', goodsTypeId: 0 }]
      this.multipleShowName = '全部'
      this.selectProduct = null
      this.$emit("input",value);
      this.$emit("change",value);
      this.$emit("clear",value);
    },
    handlerShow(){ //显示时触发
      this.$emit("show");
    },
    /**
     * 空函数
     * */
    noEvent(){},
    /**
     * 显示、隐藏列表
     */
    showListPopover(){
      this.visiblePopover = true;
      this.$emit("update:visible",true);
    },
    hideListPopover(e){
      this.visiblePopover = false;
      if(this.multiple){
        this.selectedValue = this.receiveDefaultValue(this.value);
      }
      this.searchText = "";
    },
    selectItem(item) {
      console.log('ii', item)
      let list = this.selectedValue;
      console.log(this.multiple)
      if(this.multiple){
        const index = list.findIndex((res={})=>res.id === item.id);
        if(index >=0) {
          list.splice(index,1);
        }else{
          list.push(item);
        }
        if(this.maxSelectNumber && list.length > this.maxSelectNumber){
          list.splice(0,list.length - this.maxSelectNumber);
        }
        if(this.maxSelectNumber === 1){
          // this.$emit("input",list);
          // this.$emit("change",list);
          // this.hideListPopover();
        }else{
          // 一个以上的选择点击确认按钮
        }
      }else{
        this.selectedValue = [item];
        // this.$emit("input",item);
        // this.$emit("change",item);
        // this.hideListPopover();
      }
    },
    /**
     * 判断某项值是否选中
     */
    judgeItemIsSelect(item={}){
      let list = this.selectedValue;
      return isArray(list) && list.some((res={})=>res[this.idKey] === item[this.idKey]);
      // if(this.multiple){
      //   return isArray(this.value) && this.value.some((res={})=>res[this.idKey] === item[this.idKey]);
      // }else{
      //   return this.value[this.idKey] === item[this.idKey];
      // }
    },
    searchInfoChange(val) {
      this.changeSearch(val)
      // const data = {
      //   countryId: this.countryId,
      //   productName: val,
      //   productTypeFirstName: this.firstActive.productTypeFirstName,
      //   productTypeSecondaryName: this.secondActive.productTypeSecondaryName
      // }
      // this.productLoading = true
      // this.axios.post('/api/product/selectHomePageAllProductFeeByCountryAndType', data)
      //   .then(res => {
      //     this.productItems = res.data.datas && res.data.datas.length ? res.data.datas[0].productTpeSecondaryNameList.productList : []
      //   })
    },
    /**
     * 触发搜索
     */
    changeSearch:debounce(function(text = this.searchInfo){
      text = text.replace(/(^\s+)|(\s+$)/g,"");
      console.log(text);
      // text = text.toUpperCase();
      let baseList = this.productItems
      let filterList = [];
      filterList = this.searchList(text,baseList);
      this.searchInfoFilerList = filterList;
      this.searchInfoLoading = false;

    },200,false),
    selectFirst(val) {
      this.firstActive = val
      this.secondList = val.productTpeSecondaryNameList
      this.secondActive = null
    },
    selectSecond(val) {
      this.secondActive = val
      this.productItems = val.productList
      this.searchInfo = ''
      this.searchInfoFilerList = []
    },
    selectProductItem(item) {
      console.log(111,item)
      item.goodsName = item.productName
      item.firstName = this.firstActive.productTypeFirstName
      item.secondName = this.secondActive.productTpeSecondaryName
      this.selectProduct = item
      this.productActive = item
      this.goodNameText = item.firstName + '/' + item.goodsName
      // this.$emit('change', this.selectProduct ? `${this.selectProduct.goodsName}${this.selectProduct.secondName ? `/${this.selectProduct.secondName}` : ''}${this.selectProduct.firstName ? `/${this.selectProduct.firstName}` : ''}` : '')
      this.hideProductListPopover()
    },
    selectSearchItem(item, type) {
      // type：1:精确2:检索3:清空
      if (item) {
        item.goodsName = item.goodsName || item.namec
        item.secondName = item.secondName || item.productTypeName
        item.firstName = item.firstName || item.productName
      } else {
        this.selectProduct = null
        this.levelData = []
        this.firstList = []
        this.firstActive = null
        this.secondList = []
        this.secondActive = null
        this.productItems = []
        this.searchInfo = ''
        this.searchInfoFilerList = []
        this.productActive = null
      }
      if (type === '3' || !type) {
        this.selectProduct = null
        this.levelData = []
        this.firstList = []
        this.firstActive = null
        this.secondList = []
        this.secondActive = null
        this.productItems = []
        this.searchInfo = ''
        this.searchInfoFilerList = []
        this.productActive = null
      } else if (type === '2') {
        this.firstActive = null
        this.secondActive = null
        this.searchInfo = ''
        this.productActive = null
      }
      this.selectProduct = item
      // this.$emit('change', this.selectedValue ? `${this.selectedValue.goodsName}${this.selectedValue.secondName ? `/${this.selectedValue.secondName}` : ''}${this.selectedValue.firstName ? `/${this.selectedValue.firstName}` : ''}` : '')
      this.hideProductListPopover()
    },
    showGoodNamePopover(type) {
      this.showType = type
      this.showGoodNameListPopover()
      // if (type == 1) this.goodNameText = "";
      this.getLevelList()
    },
    hideProductListPopover(e){
      this.visibleGoodsPopover = false;
      // this.goodNameText = "";
    },
    searchChange:debounce(function(val) {
      // if (val) this.showListPopover()
      if (!val) return this.showGoodNamePopover('1')
      this.$emit('remoteMethod', val)
    },500,false),
    /**
     * 搜索函数
     * @param text  {string}  搜索文本
     * @param baseList  {array} tabItem对应的list数据
     * @returns {*[]}
     */
    searchList(text="",baseList=[]){
      let filterList = [];
      let hasCallback = typeof this.searchCallback === "function";
      let filterFunction = (text="",item)=>{
        // console.log("============",item[this.itemLabelKey])
        let itemLabel = String(item.productName||"");
        let itemLabelE = String(item.productNameE||"");
        let reg = RegExp(text,"ig");
        return reg.test(itemLabel) || reg.test(itemLabelE);
      };
      filterList = baseList.filter(item=>{
        return hasCallback ? this.searchCallback(text,item) : filterFunction(text,item);
      });
      return filterList;
    },
    /**
     * 显示、隐藏商品名称列表
     */
    showGoodNameListPopover() {
      if (this.showType === '2' && !this.goodNameText) return
      this.visibleGoodsPopover = true;
    },
    async getLevelList() {
      const data = {
        countryId: this.countryId
      }
      this.levelLoading = true
      this.axios.post('/api/product/selectHomePageAllProductFeeByCountryAndType', data)
        .then(res => {
          this.levelLoading = false
          this.levelData = res.data.datas || []
          this.firstList = res.data.datas || []
        }).catch(() => {
        this.levelLoading = false
      })
    },
    confirm() {
      if (this.selectedValue.length <= 0) {
        return this.$message.error('请选择货物类型')
      }
      this.setName()
      const goodInfo = {
        goodType: this.multiple ? this.selectedValue : this.selectedValue[0],
        product: this.selectProduct
      }
      this.hideProductListPopover()
      this.hideListPopover()
      this.$emit('change', goodInfo)
    },
    /**
     * 全局关闭
     */
    globalClosePopover(e){
      let screenDoc = this.$refs.selectGoodInfo;
      if (screenDoc && !screenDoc.contains(e.target)) {
        this.hideListPopover();
        this.hideProductListPopover()
      }
    },
    setName() {
      let list = this.selectedValue;
      if(!isArray(list)) return "";
      let name = list.map((res={})=>{
        return res[this.labelKey]|| res[this.idKey]
      }).join(",");
      if (this.selectProduct && (this.selectProduct.goodsName || this.selectProduct.secondName)) {
        name += `/${this.selectProduct.goodsName || ''}/${this.selectProduct.secondName || ''}`
      }
      this.multipleShowName = name
    }
  },
  created() {
    // this.countDefaultSelect();
    document.addEventListener("click",this.globalClosePopover,false);
  },
  destroy() {
    document.removeEventListener("click",this.globalClosePopover);
  },
}
</script>

<style lang="less" scoped>
.keyword-select {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  /* 默认样式 */
  width: 100%;
  height: 50px;
  background-color: #F5F5F5;
  border-radius: 10px;

/deep/ .el-input__inner{
  height: inherit;
  line-height: inherit;
}
}
/* 搜索框 */
.search-text{
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  font-size: 16px;
&,
/deep/ input{
  background-color: transparent !important;
}
/deep/ input{
  min-width: auto;
  width: 100%;
  height: 100%;
  border: none;
}
&:not([class~="is-input"]){
   display: flex;
   align-items: center;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   padding: 0 15px;
   cursor: pointer;
   color: #999;
 }
&.is-clear{
/deep/ input{
  padding-right: 0;
}
&:not([class~="is-input"]){
   padding-right: 0;
 }
}
}
/* 弹出框内容 */
.alter-place-bpx{
  height: 328px;
  padding: 15px 11px 13px;
  font-size: 16px;
}
.opacity-0{
  opacity: 0;
}
.opacity-04{
  opacity: 0.4;
}
/* 选中值回显文本 */
.value-text{
  position: absolute;
  z-index: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  transition: opacity 0.4s ease;
&.is-clear{
   right: 30px;
 }
}
.text-row{
  padding: 0 11px;
  font-size: 16px;
  color: #333333;
  line-height: 30px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.btn-delete{
  position: relative;
  z-index: 1;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
.icon{
  cursor: pointer;
  color: #c0c4cc;
&:hover{
   color: #909399;
 }
}
}
.group-wrap {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  height: 132px;
  overflow-y: scroll;
  &__item {
    width: 100px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 11px;
    margin-top: 14px;
    background: #EEEEEE;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    .innerText {
      height: 100%;
      width: 100%;
      padding: 0 4px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 28px;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      cursor: pointer;
    }
    &.is-active {
      background: #FF4D01;
      color: #FFFFFF;
    }
  }
}
.hot-search {
  margin-bottom: 17px;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}
.history-search {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
}
.clear-history {
  color: #FF4D01;
  &:hover {
    cursor: pointer;
  }
}
.hot-search-wrap {
  margin-top: 27px;
}
.goods-name-input {
  width: 281px;
  height: 45px;
  /deep/ .el-input__inner {
    border: 1px solid #BCBCBC;
    border-radius: 10px;
    &::placeholder {
      font-size: 18px;
      font-weight: 500;
      color: #999999;
    }
  }
}
.good-name-warp {
  margin-top: 27px;
}
.confirm-button {
  width: 100%;
  margin-top: 20px;
  border-radius: 10px;
  background: #FF4D01;
}
.goods-list-box {
  display: flex;
  .goods-type-level1, .goods-type-level2, .goods-type-level3 {
    max-height: 300px;
    overflow-y: auto;
    /deep/ .el-input__inner {
      background: #F7F7F7;
      border: none
    }
    .product-wrap {
      max-width: 224px;
      padding: 10px 0;
      ul {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        li {
          padding: 3px 4px;
          width: calc(33% - 8px);
          line-height: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
          &.isActive {
            background-color: #FFF1F2;
          }
        }
      }
    }
  }
  .goods-type-level1, .goods-type-level2 {
    padding: 0 4px;
    // margin-right: 10px;
    width: 160px;
    line-height: 30px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 10px;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        background: #F5F7FA;
      }
      &.isActive {
        background: #FFF1F2;
      }
      .price-info{
        color: #FF4D01;
        font-size: 12px;
      }
    }
  }
  .goods-type-level2, .goods-type-level3 {
    // margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #efefef;
  }
}
.goods-options {
  max-height: 300px;
  overflow-y: auto;
  .goods-option {
    line-height: 30px;
    cursor: pointer;
    &:hover {
      background: #F5F7FA;
    }
  }
  .isActive {
    background: #FFF1F2;
  }
}
</style>



// WEBPACK FOOTER //
// common/newSelectPlace/searchSelectGood.vue